<oo-loading-container [status]="state.status">
  <ng-template>
    <h1 mat-dialog-title>Share link</h1>
    <mat-dialog-content>
      <p>
        Share the link below with your friends. <br/>
        After navigating to the link they will be added automatically as participants.
      </p>

      <mat-form-field appearance="outline">
        <mat-label>Share link url</mat-label>
        <input [value]="state.link" matInput readonly/>
        <button (click)="copyLink()" data-test="copy-link" mat-icon-button matSuffix>
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        Close
      </button>
    </mat-dialog-actions>
  </ng-template>
</oo-loading-container>
